import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Typography,
  ClickAwayListener,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Cancel } from '@mui/icons-material';
import React, { useState } from 'react';
import propTypes from 'prop-types';
import { useFirebase } from 'react-redux-firebase';
import { actions } from '../../actions';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  main: {
    backgroundColor: 'rgba(0,0,0,.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    zIndex: 15,
  },
  body: {
    backgroundColor: theme.palette.white.main,
    maxWidth: '500px',
    padding: 8,
    paddingBottom: 32,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  closeIconButton: {
    width: 30,
    height: 30,
  },
}));

function RecommendationPopup(props) {
  const { handleClose } = props;
  const firebase = useFirebase();
  const [text, setText] = useState();
  const classes = useStyles();
  const appDispatch = useDispatch();

  const projectId = process.env.REACT_APP_PROJECT_ID;

  const handleSendRecommendation = async () => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });

    if (!text) {
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: false, priority: 1 },
      });
      appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: 'No puede enviar una recomendación vacia',
          snackbarSeverity: 'error',
        },
      });
      return;
    }

    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(async (idToken) => {
        axios(`https://us-central1-${projectId}.cloudfunctions.net/trelloCards`, {
          method: 'post',
          headers: {
            Authorization: `bearer ${idToken}`,
          },
          data: {
            text,
          },
        })
          .then((res) => {
            if (res && res.data) {
              const status = res.data.status;
              const message = res.data.message;
              if (status === 200) {
                appDispatch({
                  type: actions.alert,
                  alert: {
                    snackbarOpen: true,
                    snackbarMessage: `¡Recomendación enviada exitosamente!`,
                    snackbarSeverity: 'success',
                  },
                });
                handleClose();
              } else if (status === 400) {
                appDispatch({
                  type: actions.alert,
                  alert: {
                    snackbarOpen: true,
                    snackbarMessage: message,
                    snackbarSeverity: 'error',
                  },
                });
              }
            }
          })
          .finally(() => {
            appDispatch({
              type: actions.changeLoading,
              loading: { loading: false, priority: 1 },
            });
          });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };

  return (
    <Box className={classes.main}>
      <ClickAwayListener onClickAway={handleClose}>
        <Grid container className={classes.body}>
          <Box display="flex" justifyContent="space-between">
            <IconButton className={classes.closeIconButton} onClick={handleClose} size="large">
              <Cancel />
            </IconButton>
            <Box mr={2}>
              <img src="/logo512.png" width="30" alt="PrestoBots" />
            </Box>
          </Box>
          <Box mx={2}>
            <Box mb={1}>
              <Typography>Queremos saber tu opinión</Typography>
            </Box>
            <Grid item sm={12}>
              <FormControl fullWidth>
                <TextField
                  multiline
                  value={text}
                  placeholder="Escribe tu recomendación"
                  onChange={(e) => setText(e.target.value)}
                  rows={6}
                  variant="outlined"
                  spellCheck="false"
                />
              </FormControl>
            </Grid>
            <Grid item sm={12}>
              <Box mt={2} display="flex" justifyContent="center">
                <Button variant="contained" color="primary" onClick={handleSendRecommendation}>
                  Enviar
                </Button>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </ClickAwayListener>
    </Box>
  );
}

const Props = {
  handleClose: propTypes.func,
};

RecommendationPopup.propTypes = Props;

export default RecommendationPopup;
